import { warn, } from 'application/console';
import pageDataObject from 'application/pageDataObject';


let apiPdo = null;

export function getApiEndpoints(endpointName = null){
  apiPdo = apiPdo || (pageDataObject.get('config.api', {}));
  const apiKeys = Object.keys(apiPdo);
  const endpointNames = apiKeys.reduce(
    (accumulator, key) => ({
      ...accumulator,
      [key.toUpperCase()]: key.toUpperCase(),
    }),
    {}
  );
  const apiEndpoints = apiKeys.reduce(
    (accumulator, key) => ({
      ...accumulator,
      [key.toUpperCase()]: apiPdo[key],
    }),
    {}
  );
  /* eslint-disable no-else-return, lines-around-comment */
  if (endpointName && endpointName in apiEndpoints) {
    const url = apiEndpoints[endpointName];
    return url && {
      url,
      endpointName: endpointNames[endpointName],
    };
  } else {
    warn(`No '${ endpointName }' in apiEndpoints! Check PDO and possibly clear Redis`, {
      endpointName,
      endpointNames,
      apiEndpoints,
      apiPdo,
    });
  }
  return {
    endpointNames,
    apiEndpoints,
  };
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/api.js